import styles from "./styles.module.scss";
import { Link } from "react-router-dom";

function Intro() {
    return (
        <>
            <section className={styles.container}>
                <div className={styles.title}>
                    <text>NOTRE PROCESSUS</text>
                    <p>pour la réussite de vos projets</p>
                </div>
                <div className={styles.bigbox}>
                    <div className={styles.service}>
                        <img src="/images/process/process.png" alt="SEO" />
                        <div className={styles.bigText}>
                            Ecoute
                        </div>
                        <div className={styles.paragraph}>
                        Comprendre le contexte et les problématiques de nos interlocuteurs avant tout.
                        </div>
                        <div className={styles.arrowContainer}>
                
                        </div>
                    </div>
                    <div className={styles.service}>
                        <img src="/images/process/specification.png" alt="web dev" />
                        <div className={styles.bigText}>
                            Qualité
                        </div>
                        <div className={styles.paragraph}>
                         Vaut mieux faire peu, mais bien (très bien même...), tel est notre credo.
                        </div>
                        <div className={styles.arrowContainer}>
           
                        </div>
                    </div>
                    <div className={styles.service}>
                        <img src="/images/process/design.png" alt="mobile dev" />
                        <div className={styles.bigText}>
                          Expertise
                        </div>
                        <div className={styles.paragraph}>
                         Fruit des années d'expérience, des projets délivrés et de nos efforts continus de capitalisation.
                        </div>
                        <div className={styles.arrowContainer}>
            
                        </div>
                    </div>
                    <div className={styles.service}>
                        <img src="/images/process/integration.png" alt="SEO" />
                        <div className={styles.bigText}>
                          Transparence
                        </div>
                        <div className={styles.paragraph}>
                         Ancrée dans notre ADN et devenue progressivement indispensable pour réussir nos projets.
                        </div>
                        <div className={styles.arrowContainer}>
           
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Intro;